import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import QuizDetails from '../components/quiz/QuizDetails'

const QuizDetailsPage = () => {
  return (
    <>
    
    <Navbar/>
    <QuizDetails/>
    </>
  )
}

export default QuizDetailsPage